











































import { IAddress } from "@/types/address.model";
import { PropType } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AddressInfo extends Vue {
  @Prop({ required: true, type: Object as PropType<IAddress> })
  address!: IAddress;

  @Prop({ required: false, default: false, type: Boolean }) showIcon!: boolean;
  @Prop({ required: false, default: false, type: Boolean })
  showTimezone!: boolean;
  @Prop({ required: false, type: String }) userTimezone!: string;

  get userTimezoneDifferent(): boolean {
    return (
      this.userTimezone != undefined &&
      this.address.timezone != undefined &&
      this.userTimezone !== this.address.timezone
    );
  }

  get longShortTimezoneNamesDifferent(): boolean {
    return (
      this.timezoneLongName != undefined &&
      this.timezoneShortName != undefined &&
      this.timezoneLongName !== this.timezoneShortName
    );
  }

  get timezoneLongName(): string | undefined {
    return this.timezoneName("long");
  }

  get timezoneShortName(): string | undefined {
    return this.timezoneName("short");
  }

  get timezoneLongNameValid(): boolean {
    return (
      this.timezoneLongName != undefined && !this.timezoneLongName.match(/UTC/)
    );
  }

  private timezoneName(format: "long" | "short"): string | undefined {
    return this.extractTimezone(
      new Intl.DateTimeFormat(undefined, {
        timeZoneName: format,
        timeZone: this.address.timezone,
      }).formatToParts()
    );
  }

  private extractTimezone(
    parts: Intl.DateTimeFormatPart[]
  ): string | undefined {
    return parts.find((part) => part.type === "timeZoneName")?.value;
  }
}
